import styled from 'styled-components';
import { AccordionMixin } from '../../mixins/components/AccordionMixin';
export var StyledAccordion = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledAccordion",
  componentId: "c11n-8-111-1__sc-158b3u3-0"
})(["", ""], AccordionMixin);